import { Language, LanguageCode } from "../../../../eventfive.awi.mosaic-pwa/theme/ts/awi/model/Language.js";
import { Resource as ResourcePwa } from "../../../../eventfive.awi.mosaic-pwa/theme/ts/awi/model/Resource.js";
import { Breadcrumb } from "./display/Breadcrumb.js";
import { CategoryView } from "./display/CategoryView.js";
import { Home } from "./display/Home.js";
import { Logo } from "./display/Logo.js";
import { VideoOverlay } from "./display/VideoOverlay.js";
import { DataManager } from "./model/DataManager.js";
import { Resource } from "./model/Resource.js";

export type ApplicationIdleMode = "panorama" | "category" | "video" | "none";

export class Application {

    public element: HTMLDivElement;
    public screenWidth: number = 1920;
    public screenHeight: number = 1080;

    private _data: DataManager;
    private _home: Home;
    private _view: CategoryView;
    private _idleMode: ApplicationIdleMode = "none";
    private _panoramaInterval: any = null;
    private _idleTimeout: any = null;
    private _videoOverlay: VideoOverlay = null;

    constructor() {
        (window as any).$ = jQuery;

        this.element = document.getElementById("app") as HTMLDivElement;
        this.element.classList.add("no-transition");
        Resource.init(this.element);
        ResourcePwa.init(this.element);

        this.screenWidth = this.element.offsetWidth;
        this.screenHeight = this.element.scrollHeight;

        this.resize();

        if (e5.Url.params.has("lang")) {
            Language.current = e5.Url.params.get("lang", "en") as LanguageCode;
        } else if (e5.Url.params.has("language")) {
            Language.current = e5.Url.params.get("language", "en") as LanguageCode;
        } else {
            Language.current = "en";
        }

        this._data = new DataManager();
        this._data.onComplete.add(() => this.ready());

        var url = Resource.DATA;
        if (e5.Url.params.has("refresh")) {
            url = e5.Url.params.set("refresh", "", url);
        }
        this._data.load(url);

        window.addEventListener("resize", () => this.resize());
    }

    private async ready(): Promise<boolean> {
        this._home = new Home(this._data, this.screenWidth, this.screenHeight);
        this.element.append(this._home.element);
        await this._home.create();

        this._view = new CategoryView(this._data);
        this.element.append(this._view.element);

        var breadcrumb = new Breadcrumb();
        this.element.append(breadcrumb.element);

        var logo = new Logo(this._home.home);
        logo.onRequestCategory.add((c) => this._home.open(c));
        this.element.append(logo.element);

        this._home.onOpenCategory.add((category) => {
            breadcrumb.category = category;
            this._view.open(category);
        });

        this._home.onChangeActive.add((active) => {
            // logo.active = active;
        });

        this._view.onClose.add(() => {
            this._home.active = true;
            breadcrumb.category = null;
            breadcrumb.entry = null;
        });

        this._view.onSelectEntry.add((entry) => {
            breadcrumb.entry = entry;
        });

        //Disable "Idle Mode" in "Edit Mode".
        if (!e5.Url.params.has("edit")) {
            document.addEventListener("keyup", (e) => {
                if (e5.KeyCode.is(e, e5.KeyCode.KEY_R)) {
                    this.setIdleMode(this._data.config.idle_mode);
                }
            }, true);

            document.addEventListener("pointerdown", (e) => {
                this.refreshIdleTimeout();
                if (this._idleMode != "none") {
                    this.setIdleMode("none");
                    return;
                }
            }, true);
            this.refreshIdleTimeout();
        }

        setTimeout(() => {
            this.element.classList.remove("no-transition");
            this.element.classList.remove("progress");
        }, 0);

        //For testing
        // home.open(this._data.data.category.whereFirst("title", "Live"));

        // var r = e5.Resize.create(document.body);
        // r.add(() => {
        //     console.log("BODY RESIZED");
        // });

        // r.dispose();
        // home.open(this._data.data.category.whereFirst("title", "In the press"));

        return true;
    }

    private refreshIdleTimeout(): void {
        clearTimeout(this._idleTimeout);
        this._idleTimeout = setTimeout(
            () => this.setIdleMode(this._data.config.idle_mode),
            1000 * this._data.config.idle_mode_timeout);
    }

    private setIdleMode(idleMode: ApplicationIdleMode): void {
        if (this._idleMode == idleMode) {
            return;
        }

        this._view.reset();
        clearTimeout(this._idleTimeout);

        //Exit idle mode
        if (this._idleMode == "none") {

        }
        else if (this._idleMode == "panorama") {
            clearInterval(this._panoramaInterval);
        }
        else if (this._idleMode == "category") {
        }

        this._idleMode = idleMode;

        //Enter idle mode
        if (idleMode == "none") {

        }
        else if (idleMode == "panorama") {
            this._view.close();
            this._home.idleNext();
            this._panoramaInterval = setInterval(() => this._home.idleNext(), 8000);
        }
        else if (idleMode == "category") {
            if (this._data.config.initial_category)
                this._home.tweenToCategory(this._data.config.initial_category);
            this._home.open(this._data.config.idle_mode_category);
        }
        else if (idleMode == "video") {
            this._view.close();
            if (!this._videoOverlay) {
                this._videoOverlay = new VideoOverlay(this.element);
            }

            var video = Language.current == "en" ? this._data.config.idle_mode_video_en || this._data.config.idle_mode_video_de
                : this._data.config.idle_mode_video_de || this._data.config.idle_mode_video_en;
            if (video) {
                this._videoOverlay.open(video);
            }
        }
    }

    private resize(): void {
        var elements = [this.element];

        var w = window.innerWidth;
        var h = window.innerHeight;
        var upScaling = e5.Url.params.has("upscaling");

        for (var element of elements) {
            var elementWidth = element.offsetWidth;
            var elementHeight = element.offsetHeight;

            var scale = Math.min(w / elementWidth, h / elementHeight);
            if (!upScaling)
                scale = Math.min(scale, 1);

            if (scale == 1 && w === elementWidth && h === elementHeight) {
                element.style.transform = "initial";
                element.style.top = "50%";
                element.style.left = "50%";
                element.style.marginTop = -this.screenHeight * 0.5 + "px";
                element.style.marginLeft = -this.screenWidth * 0.5 + "px";
            }
            else {
                var x = (w - elementWidth * scale) * 0.5;
                var y = (h - elementHeight * scale) * 0.5;
                element.style.transform = "translate(" + Math.round(x) + "px, " + Math.round(y) + "px) scale(" + scale + ")";
                element.style.top = null;
                element.style.left = null;
                element.style.marginTop = null;
                element.style.marginLeft = null;
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    if (document.getElementById("app"))
        new Application();
});